export default function SpiralTM() {
  return (
    <>
      SPIRAL<sup>TM</sup>
    </>
  );
}
